import { Dialog } from "@headlessui/react";
import { ModalFoterBox } from "../../components/box/Box";
import Button from "../../components/button/Button";
import { Modal, ModalProp } from "../../components/modal/Modal";
import TableList, { GridCol, GridRow } from "../../components/table/TableList";
import { Spiner } from "../../components/spinner/Spiner";

export type MovieContentsModalProp = {
  videoContentsCols: GridCol[];
  videoContentsRows: GridRow[];
  onContentsAdd: () => void;
  isLoad: boolean;
}

export const MovieContentsModal = ({
  open,
  toggle,
  onContentsAdd,
  closeOnClickOutside,
  videoContentsCols,
  videoContentsRows,
  isLoad,
}: ModalProp & MovieContentsModalProp) => {

  return (
    <>
      <Modal
        open={open}
        toggle={toggle}
        closeOnClickOutside={closeOnClickOutside}
      >
        <Dialog.Panel className=" relative transform overflow-hidden rounded-lg bg-white  text-left shadow-xltransition-all sm:w-full max-w-screen-2xl ">
          <div className="text-center sm:mt-3">
            <div className={"flex items-center"}>
              <Dialog.Title
                as="h3"
                className="text-left p-4 text-lg font-medium leading-6 text-gray-900 flex-1"
              >
                動画コンテンツ一覧
              </Dialog.Title>
              <Button
                className={"mr-4"}
                size={'sm'}
                outline
                onClick={onContentsAdd}
                children={"動画コンテンツ新規登録"}
              />
            </div>
            <div className="overflow-y-auto">
              <div className="text-left max-h-[calc(100vh_-_16rem)] px-4 pb-4 pt-1">
                {isLoad ? (<Spiner/>) :
                  (<TableList
                    gridCol={videoContentsCols}
                    gridRow={videoContentsRows}
                    limit={50}
                    header
                  />)
                }
              </div>
            </div>
          </div>
          <ModalFoterBox>
            <Button
              className="mx-2 mt-1"
              onClick={toggle}
              children={"閉じる"}
            />
          </ModalFoterBox>
        </Dialog.Panel>
      </Modal>
    </>
  )
}